module.exports = __webpack_public_path__ + "static/media/chair-6.31c8534d.png";